export const REACT_REFERENCE = 'https://console.integration.app/ref/react/'
export const SDK_REFERENCE = 'https://console.integration.app/ref/sdk/'
export const REST_API_REFERENCE = 'https://api-reference.integration.app'
